import { useCallback, useState } from 'react'

import useLDFlags from 'data/hooks/useLDFlags'
import { useRecordSupportsEditing } from 'features/views/attributes/editable/hooks/useRecordSupportsEditing'

export function useEditableSectionState() {
    const [isOpen, setIsOpen] = useState(false)

    const { flags } = useLDFlags()
    const recordSupportsEditing = useRecordSupportsEditing()
    const isEditable = recordSupportsEditing && flags.detailViewHeaderInlineEditing

    const onInteractOutside = useCallback((e: Event) => {
        const el = e.target as HTMLElement | null
        if (!el) return

        if (el.closest('.ag-custom-component-popup')) {
            e.preventDefault()
        }
    }, [])

    return {
        isOpen,
        onOpenChange: setIsOpen,
        isEditable,
        onInteractOutside,
    }
}
